<template>
  <div class="professional-picture-box">
    <a :href="'/cleaner/'+professional.id" target="_blank">
      <img v-lazy="professionalPicture()"
           class="rounded-circle"
           :class="imgClass"
           :width="imgSize">
    </a>
    <router-link to="/excellent-provider" target='_blank' v-if="professional.is_excellent === 1">
      <img src="/static/img/ic_badge_excellent.png"
           class="badge-excellent"
           :width="(badgeSize) ? badgeSize : '30%'"
           v-b-popover.hover.top="$i18n.t('message.professional.excellent_provider_detail', {name: firstName(professional)})"
           :title="$i18n.t('message.professional.excellent_provider_title')">
    </router-link>
  </div>
</template>

<script>
  export default {
    props: {
      professional: Object,
      imgClass: String,
      imgSize: Number,
      badgeSize: Number
    },
    methods: {
      professionalPicture () {
        let url = this.professional.picture
        if (this.professional.full_picture) {
          url = this.professional.full_picture
        }
        return url
      },
      firstName (professional) {
        let name = ''
        if (professional.firstname) {
          name = professional.firstname + ' ' + professional.lastname
        } else if (professional.name) {
          name = professional.name
        } else if (professional.full_name) {
          name = professional.full_name
        }

        if (name) {
          name = this.$options.filters.firstName(name)
        } else {
          name = this.$i18n.t('message.professional.this_provider')
        }

        return name
      },
      validUrl (str) {
        const regexp = /^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/
        return regexp.test(str)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/professional/components/ProfessionalPicture.vue